import * as React from 'react';
import { DSThemeContextManagerType, Themeable, ThemeType } from './types';

/**
 * Previous props when using as ThemeContext.Provider directly
 *
 * @deprecated apply these values directly as props instead
 */
interface DeprecatedThemeable {
  /** Leveraged when Theme was used directly as a Provider in V2 */
  value: Themeable;
}

export const dsThemeContextManager: DSThemeContextManagerType & Themeable = {
  /** @param value - new value for the baseTheme */
  setTheme: (value: ThemeType) => {
    dsThemeContextManager.theme = value;
  },
  /** Method to  get the current baseTheme in use. */
  getCurrentTheme: () => dsThemeContextManager.theme
};

/** Utility to allow apps to set starting baseTheme. */
export const setTheme = (value: ThemeType) => {
  dsThemeContextManager.setTheme(value);
};

export const ThemeContext = React.createContext<Themeable>({
  theme: 'intuit',
  colorScheme: 'light',
  ...dsThemeContextManager
});

/**
 * A theme-ing context for a part of your react application
 *
 * Backwards compatible with V2 of design-systems/theme where Theme was an
 * alias for ThemeContext.Provider rather than being a custom component. This
 * ensures the runtime version doesn't cause older plugins to now break since
 * design-systems/theme wasn't added to the runtime until V3.
 */
export const Theme = ({
  children,
  ...props
}: React.PropsWithChildren<Themeable | DeprecatedThemeable>) => {
  const wrappedTheme = React.useContext(ThemeContext);
  const value: Themeable = 'value' in props ? props.value : props;

  return (
    <ThemeContext.Provider value={{ ...wrappedTheme, ...value }}>
      {children}
    </ThemeContext.Provider>
  );
};
